define('SageDotCom/Components/Content/CustomerSuccess/CustomerSuccessFilter',["jquery",
    "knockout",
    "underscore",
    "eventManager",
    "SageDotCom/DataLayer/Events/CustomerSuccess/filterPaneEvent",
    "SageDotCom/DataLayer/Events/CustomerSuccess/filterEvent",
    "jqueryQuerystring"],
    function ($, ko, _, eventManager, filterPaneEvent, filterEvent) {
        
        function SpotlightFilters(scope, countText, countTextPlural, industryText, featureText, productText, currentMarket, marketData, marketsLabel) {
            var facetTypes = {
                industry: "Industry",
                products: "Products",
                features: "Features",
                markets: "Markets"
            };

            function init() {
                Object.defineProperty(this, "scope", { enumerable: true, value: scope, writable: !1 });
                Object.defineProperty(this, "$scope", { enumerable: !0, value: $(scope) });

                //Process the input data into a format for the viewModel to interact with
                var marketObjects = [];
                _.map(marketData,
                    function(market) {
                        marketObjects.push(new MarketObj(market.ID, market.Name, market.ISOCode, market.Data));
                    });

                //Create and apply the viewModel
                var stickyNav = $(".sticky-nav.spotlight").get(0);
                var wrapper = $scope.find(".customer-success-filter-wrapper").get(0);
                var viewModel = new FilterViewModel(marketObjects, stickyNav, wrapper);

                if (wrapper) {
                    ko.applyBindings(viewModel, wrapper);
                }

                if (stickyNav) {
                    $(window).scroll(viewModel.pinWrapperBelowStickyNav);
                    $(window).resize(viewModel.pinWrapperBelowStickyNav);
                }

                $(".customer-success-filter-button").addClass("prevent-tracking").removeAttr("href");

                $(".customer-success-filter-button").on("click keydown",
                    function(e) {
                        if (e.type === "click" || keyDownCheck(e.keyCode)) {
                            var opening = viewModel.toggle(e.currentTarget);
                            new filterPaneEvent("Button Click", opening, false, this).trigger();
                        }
                    });

                //Close the filter if anything other than the pane or filter button is clicked
                $(document).click(function(e) {
                    if (viewModel.isOpen()) {
                        //If clicked on the filter pane itself, don't close
                        var parents = $(e.target).parents();
                        var filterClicked = parents.hasClass("customer-success-filter-pane") ||
                            $(e.target).hasClass("customer-success-filter-pane");

                        if (!filterClicked) {
                            //if a filter button was clicked, ignore the event
                            var buttonClicked = parents.hasClass("customer-success-filter-button") ||
                                $(e.target).hasClass("customer-success-filter-button");

                            if (!buttonClicked) {
                                viewModel.hide();

                                var overlayClicked = parents.hasClass("customer-success-filter-overlay") ||
                                    $(e.target).hasClass("customer-success-filter-overlay");
                                if (overlayClicked) {
                                    new filterPaneEvent("Filter Overlay", false, false, e.target).trigger();
                                } else {
                                    new filterPaneEvent("Body Click", false, false, e.target).trigger();
                                }
                            }
                        }
                    }
                });

                $(document).keydown(function(e) {
                    if (viewModel.isOpen() && e.keyCode === 27) {
                        //Escape was pressed, close the filter
                        viewModel.hide();
                    }
                });
            }

            function keyDownCheck(keyCode) {
                return keyCode === 13 || keyCode === 32;
            }

            function getMatchingFacet(searchCollection, idTofind) {
                return _.findWhere(searchCollection, { id: idTofind });
            }

            //Given the data collection, return the data that matches the given facet Id
            function filterDataObjectsByFacet(dataCollection, facetType, facetId) {
                if (facetType === facetTypes.industry) {
                    return _.filter(dataCollection,
                        function (dataObj) {
                            return dataObj[facetTypes.industry].ID === facetId;
                        });
                } else {
                    return _.filter(dataCollection,
                        function (dataObj) {
                            return _.some(dataObj[facetType], { ID: facetId });
                        });
                }
            }

            function normaliseDataObjects(data) {
                _.map(data,
                    function (dataObject) {
                        dataObject[facetTypes.industry] = {
                            ID: dataObject.CustomerIndustryInfo.Id,
                            Text: dataObject.CustomerIndustryInfo.Text
                        };
                        dataObject[facetTypes.features] = [];
                        _.map(dataObject.CustomerProductFeatureInfo,
                            function (featureInfo) {
                                dataObject[facetTypes.features].push({
                                    ID: featureInfo.Id,
                                    Text: featureInfo.Text
                                });
                            });
                        dataObject[facetTypes.products] = [];
                        _.map(dataObject.CustomerSuccessProductDetails,
                            function (productInfo) {
                                dataObject[facetTypes.products].push({
                                    ID: productInfo.ProductId,
                                    Text: productInfo.ProductText
                                });
                            });
                    });
                return data;
            }


            //Represents a Market and the associated stories
            function MarketObj(id, name, isocode, data) {
                var self = this;
                self.id = id;
                self.isocode = isocode;
                self.name = name;
                self.data = normaliseDataObjects(data);
                self.countText = "(" + self.data.length + ")";

                self.selected = ko.observable(false);
                self.isDisabled = ko.observable(false);
                self.isVisible = ko.observable(false);
                
                self.keyDownToggle = function (vm, e) {
                    if (keyDownCheck(e.keyCode)) {
                        self.toggle();
                    }
                }


                self.toggle = function () {
                    if (!self.isDisabled()) {
                        var newVal = !self.selected();
                        self.selected(newVal);

                        new filterEvent(false, false, newVal, self.name, marketsLabel).trigger();
                    }
                }

                //Return the data for this market
                self.getFacetData = function () {
                    var returnData = {
                        industries: [],
                        features: [],
                        products: []
                    };

                    //For each facet, if it already exists in the return data, increment the count, otherwise create it
                    _.map(self.data,
                        function (data) {
                            var existing = getMatchingFacet(returnData.industries, data[facetTypes.industry].ID);
                            if (existing) {
                                existing.count++;
                            } else {
                                returnData.industries.push({
                                    id: data[facetTypes.industry].ID,
                                    name: data[facetTypes.industry].Text,
                                    count: 1
                                });
                            }

                            _.map(data[facetTypes.features],
                                function (feature) {
                                    var existing = getMatchingFacet(returnData.features, feature.ID);
                                    if (existing) {
                                        existing.count++;
                                    } else {
                                        returnData.features.push({
                                            id: feature.ID,
                                            name: feature.Text,
                                            count: 1
                                        });
                                    }
                                });

                            _.map(data[facetTypes.products],
                                function (product) {
                                    var existing = getMatchingFacet(returnData.products, product.ID);
                                    if (existing) {
                                        existing.count++;
                                    } else {
                                        returnData.products.push({
                                            id: product.ID,
                                            name: product.Text,
                                            count: 1
                                        });
                                    }
                                });
                        });

                    return returnData;
                }
            }

            //Represents a collection of facets (i.e. Industries/Products/Features)
            function FacetCollection(name, type, rootViewModel) {
                var self = this;

                self.name = name;
                self.type = type;
                self.facetLimit = rootViewModel.facetLimit;
                self.rootViewModel = rootViewModel;

                self.facets = ko.observableArray();
                self.isOpen = ko.observable(false);

                self.hasFacets = ko.computed(function () {
                    return self.facets().length > 0;
                });

                //Toggles whether or not all the facets are shown, or only the first 8 (facet limit)
                self.keyDownToggle = function (vm, e) {
                    if (keyDownCheck(e.keyCode)) {
                        self.toggle(vm, e);
                    }
                }

                self.toggle = function (vm, e) {
                    self.isOpen(!self.isOpen());
                    self.dealWithVisibility();

                    $(e.target).siblings("[tabindex]:visible").focus();
                    if (!self.isOpen()) {
                        var parentSection = $(e.target).parents(".customer-success-filter-section");
                        if (parentSection.position().top < 0) {
                            var filterPane = $(".customer-success-filter-pane");
                            filterPane.animate({ scrollTop: filterPane.scrollTop() + parentSection.position().top }, 500);
                        }
                    }
                };

                //Handles showing/hiding the facets
                self.dealWithVisibility = function () {
                    //If all the facets should be shown, show them
                    if (self.isOpen()) {
                        _.map(self.facets(),
                            function (facet) {
                                facet.isVisible(true);
                            });
                    } else {
                        //Otherwise, only show the first 8 (facet limit)
                        for (var i = 0; i < self.facetCount(); i++) {
                            if (i < self.facetLimit) {
                                self.facets()[i].isVisible(true);
                            } else {
                                self.facets()[i].isVisible(false);
                            }
                        }
                    }
                };

                self.facetCount = ko.computed(function () {
                    return self.facets().length;
                });

                //Should the show more/show less element be displayed?
                self.showExpando = ko.computed(function () {
                    return self.facetCount() > self.facetLimit;
                });

                //Add facets to this collection
                self.addFacets = function (collection) {
                    _.map(collection,
                        function (facet) {
                            //If the facet already exists in this collection, increase the count by the number of stories added
                            var existing = getMatchingFacet(self.facets(), facet.id);

                            if (existing != null) {
                                existing.number(existing.number() + facet.count);
                            } else {
                                //Otherwise, create the new facet and add appropriate event subscriptions
                                var facetObj = new FilterFacet(facet.id, facet.name, self.name);
                                facetObj.number(facet.count);

                                facetObj.addSelectedSubscription(self.rootViewModel);

                                self.facets.push(facetObj);
                            }
                        });

                    //Sort the facets into alphabetical order
                    self.facets(_.sortBy(self.facets(), "name"));
                    self.dealWithVisibility();
                }

                //Subtract the stories that are no longer relevant (i.e. a market was deselected)
                self.subtractFacets = function (toSubtract, toKeep) {
                    //Remove facets that are not included in the toKeep collection 
                    var filtered = _.filter(self.facets(),
                        function (facet) {
                            var existing = filterDataObjectsByFacet(toKeep, self.type, facet.id);
                            return existing !== null && existing !== undefined && existing.length > 0;
                        });

                    //For facets that are about to be removed, unsubscribe from the selected event 
                    _.map(self.facets(),
                        function (facet) {
                            if (!_.contains(filtered, facet)) {
                                facet.removeSelectedSubscription();
                            }
                        });

                    self.facets(filtered);

                    //For each facet in this FacetCollection, subtract the count of the removed facet from the existing one
                    _.map(toSubtract,
                        function (facet) {
                            var existing = getMatchingFacet(self.facets(), facet.id);
                            if (existing != null) {
                                existing.number(existing.number() - facet.count);
                            }
                        });

                    self.dealWithVisibility();
                }

                //Programmatically select the specified facets
                self.selectFacets = function (toSelect, deselectOthers) {
                    _.map(self.facets(),
                        function (facet) {
                            if (_.contains(toSelect, facet.id)) {
                                facet.selected(true);
                            } else {
                                if (deselectOthers) {
                                    facet.selected(false);
                                }
                            }
                        });
                }

                //Reset the collection to default (i.e. nothing selected)
                self.reset = function () {
                    _.map(self.facets(),
                        function (facet) {
                            facet.enable();
                            facet.selected(false);
                        });

                    self.dealWithVisibility();
                }

                //Return the facets that are currently selected
                self.getSelectedFacets = function () {
                    var selected = [];
                    _.map(self.facets(),
                        function (facet) {
                            if (facet.selected()) {
                                selected.push(facet);
                            }
                        });

                    return selected;
                }

                self.recalculateCounts = function (dataCollection, selectedIndustries, selectedFeatures, selectedProducts) {
                    var filterToApply = {};
                    filterToApply[facetTypes.industry] = selectedIndustries;
                    filterToApply[facetTypes.features] = selectedFeatures;
                    filterToApply[facetTypes.products] = selectedProducts;

                    if (self.type == facetTypes.industry) {
                        filterToApply[facetTypes.industry] = [];
                    }
                    if (self.type == facetTypes.features) {
                        filterToApply[facetTypes.features] = [];
                    }
                    if (self.type == facetTypes.products) {
                        filterToApply[facetTypes.products] = [];
                    }

                    recalculateCountsUsingFilter(dataCollection, filterToApply);
                }

                function recalculateCountsUsingFilter(dataCollection, filterData) {
                    _.map(self.facets(),
                        function (facet) {
                            //first of all, get the data that is relevant to this particular facet
                            var relevantData = filterDataObjectsByFacet(dataCollection, self.type, facet.id);

                            //next, need to further filter the data to make sure it adheres to the other aspects of the filter
                            if (filterData[facetTypes.industry].length > 0) {
                                relevantData = _.filter(relevantData,
                                    function (dataObj) {
                                        //if the data adheres to any of the industries, then it is valid
                                        return _.some(filterData[facetTypes.industry],
                                            { id: dataObj[facetTypes.industry].ID });
                                    });
                            }

                            if (filterData[facetTypes.features].length > 0) {
                                relevantData = _.filter(relevantData,
                                    function (dataObj) {
                                        //if the data adheres to any of the features, it is valid
                                        var matchingFeatures = _.filter(dataObj[facetTypes.features],
                                            function (dataObjFeature) {
                                                return _.some(filterData[facetTypes.features],
                                                    { id: dataObjFeature.ID });
                                            });

                                        return matchingFeatures.length > 0;
                                    });
                            }

                            if (filterData[facetTypes.products].length > 0) {
                                relevantData = _.filter(relevantData,
                                    function (dataObj) {
                                        //if the data adheres to any of the products, it is valid
                                        var matchingProducts = _.filter(dataObj[facetTypes.products],
                                            function (dataObjProduct) {
                                                return _.some(filterData[facetTypes.products],
                                                    { id: dataObjProduct.ID });
                                            });

                                        return matchingProducts.length > 0;
                                    });
                            }

                            facet.updateCount(relevantData.length);
                        });
                }

                //Function to get the data that matches any of the facets that are selected in this collection
                //If no facets are selected, will return the unmodified collection
                self.filterDataUsingSelectedFacets = function (dataCollection) {
                    var selectedFacets = self.getSelectedFacets();

                    if (selectedFacets.length > 0) {
                        var selectedFacetIds = _.pluck(selectedFacets, "id");

                        if (self.type == facetTypes.industry) {
                            dataCollection = _.filter(dataCollection,
                                function (dataObj) {
                                    return _.contains(selectedFacetIds, dataObj[facetTypes.industry].ID);
                                });
                        } else {
                            dataCollection = _.filter(dataCollection,
                                function (dataObj) {
                                    //Need to check each of the facet entries on the data itself
                                    return _.some(dataObj[self.type],
                                        function (dataObjFacet) {
                                            return _.contains(selectedFacetIds, dataObjFacet.ID);
                                        });
                                });
                        }
                    }
                    return dataCollection;
                }
            }

            //Represents an individual facet
            function FilterFacet(id, name, collectionName) {
                var self = this;
                self.id = id;
                self.name = name;
                self.collectionName = collectionName;

                self.selectedSubscription = null;

                self.selected = ko.observable(false);
                self.isDisabled = ko.observable(false);
                self.isVisible = ko.observable(false);
                self.number = ko.observable(0);

                //Update the count of stories connected to this facet
                self.updateCount = function (number) {
                    self.number(number);
                    //If there are no stories, disable this facet
                    if (number == 0) {
                        self.disable();
                    } else {
                        self.enable();
                    }
                };

                //Display text for the number of stories connected to this facet
                self.countText = ko.computed(function () {
                    if (self.number() > 0) {
                        return "(" + self.number() + ")";
                    } else {
                        return null;
                    }
                });

                self.enable = function () {
                    self.isDisabled(false);
                };

                self.disable = function () {
                    self.isDisabled(true);
                    self.selected(false);
                };

                self.keyDownToggle = function (vm, e) {
                    if (keyDownCheck(e.keyCode)) {
                        self.toggle();
                    }
                }

                self.toggle = function () {
                    if (!self.isDisabled()) {
                        var newVal = !self.selected();
                        self.selected(newVal);

                        new filterEvent(false, false, newVal, self.name, self.collectionName).trigger();
                    }
                };

                //Add a subscription to update the filter when this facet is selected
                self.addSelectedSubscription = function (rootViewModel) {
                    self.selectedSubscription = self.selected.subscribe(function () {
                        rootViewModel.updatefilter();
                    });
                }

                //Remove the subscription from memory
                self.removeSelectedSubscription = function () {
                    if (self.selectedSubscription != null) {
                        self.selectedSubscription.dispose();
                    }
                }
            }

            function FilterViewModel(markets, stickyNav, wrapper) {
                var self = this;

                self.countTextSelector = ".spotlight .filter-result-count";

                self.isOpen = ko.observable(false);
                self.paneIsOpen = ko.observable(false);
                self.markets = markets;
                self.isResetting = false;
                self.isInitialising = false;

                self.debounceQuerystringUpdate = _.debounce(function(queryStringDict) {
                    var queryString = "?";
                    _.map(queryStringDict,
                        function (entry, key) {
                            if (entry.length > 0 && key.length > 0) {
                                if (queryString !== "?") {
                                    queryString += "&";
                                }
                                queryString += key + "=" + entry;
                            }
                        });

                    history.pushState("", "", queryString);
                }, 500);

                //The maximum number of facets that should be shown without "expanding" the collection
                self.facetLimit = 8;

                self.marketListOpen = ko.observable(false);
                self.isOpen = ko.observable(false);
                self.isFiltered = ko.observable(false);
                self.totalCount = ko.observable(0);
                self.filteredDataCount = ko.observable(0);
                self.facetCollections = ko.observableArray();
                self.triggeringElement = undefined;
                function initViewModel() {
                    $(self.countTextSelector).each(function (index, el) {
                        var text = el.innerText;
                        $(el).data("customer-success-text-format", text).hide();
                    });
                    self.isInitialising = true;
                    self.isResetting = true;

                    self.facetCollections().push(new FacetCollection(industryText, facetTypes.industry, self));
                    self.facetCollections().push(new FacetCollection(featureText, facetTypes.features, self));
                    self.facetCollections().push(new FacetCollection(productText, facetTypes.products, self));

                    var shouldOpen = $.Querystring("openFilter") || "";

                    //If no markets are selected in the query string, use the default (the current market)
                    var queryStrMarkets = $.Querystring(facetTypes.markets) || "";
                    if (queryStrMarkets == "") {
                        var existing = _.findWhere(self.markets, { isocode: currentMarket });
                        if (existing) {
                            queryStrMarkets = existing.id;
                        }
                    }

                    var selectedMarkets = queryStrMarkets.split(",");

                    for (var i = 0; i < self.markets.length; i++) {
                        var market = self.markets[i];
                        //Subscribe to selecting/deselecting the market
                        market.selected.subscribe(function () {
                            self.updateFacetsFromMarket(this);
                        }, market);

                        //If the market is selected in the query string, select it in the model
                        if (_.contains(selectedMarkets, market.id)) {
                            market.selected(true);
                        }

                        //Increase the count of stories with the number of stories in the market
                        self.totalCount(self.totalCount() + market.data.length);

                        //Show the first 8 markets (facetLimit)
                        if (i < self.facetLimit) {
                            market.isVisible(true);
                        }
                    }

                    //For each facet type
                    _.map(self.facetCollections(),
                        function (facetCollection) {
                            //If the facet is selected in the querystring, select it in the model
                            var queryString = $.Querystring(facetCollection.type) || "";
                            if (queryString.length > 0) {
                                var toSelect = [];
                                var selectedFacets = queryString.split(",");
                                _.map(selectedFacets,
                                    function (facet) {
                                        toSelect.push(facet);
                                    });

                                facetCollection.selectFacets(toSelect, false);
                            }

                            facetCollection.dealWithVisibility();
                        });

                    self.isResetting = false;
                    self.updatefilter();
                    self.isInitialising = false;

                    $(self.countTextSelector).show();
                    if (shouldOpen) {
                        self.show(true);
                    } else {
                        self.pinWrapperBelowStickyNav();
                    }
                }

                self.pinWrapperBelowStickyNav = function() {
                    if (stickyNav) {
                        var newTop = stickyNav.getBoundingClientRect().bottom;
                        $(wrapper).css("top", newTop + "px");
                    }
                };

                //Toggle the filter pane
                self.toggle = function (triggeringEl) {
                    var opening = false;
                    self.triggeringElement = triggeringEl;
                    if (self.isOpen()) {
                        self.hide();
                    } else {
                        opening = true;
                        self.show(false);
                    }

                    return opening;
                };
                
                self.keyDownHide = function (vm, e) {
                    if (keyDownCheck(e.keyCode)) {
                        self.hide();
                    }
                }

                self.getAllFocusableElements = function() {
                    return $(".customer-success-filter-pane [tabindex]:visible");
                };

                self.changeFocus = function(e) {
                    if (e.keyCode === 9) {
                        e.preventDefault();

                        var focusableElements = self.getAllFocusableElements();
                        var currentIndex = focusableElements.index(e.target);
                        if (e.shiftKey) {
                            //backwards
                            if (currentIndex <= 0) {
                                focusableElements.last().focus();
                            } else {
                                $(focusableElements.get(currentIndex - 1)).focus();
                            }
                        } else {
                            //forwards
                            if (currentIndex === focusableElements.length - 1) {
                                focusableElements.first().focus();
                            } else {
                                $(focusableElements.get(currentIndex + 1)).focus();
                            }
                        }
                    }
                };

                self.hide = function() {
                    if (self.paneIsOpen()) {
                        self.paneIsOpen(false);
                        window.setTimeout(function() {
                                self.isOpen(false);
                                $("body").removeClass("customer-success-no-scroll");
                                document.removeEventListener("keydown", self.changeFocus, true);
                                if (self.triggeringElement) {
                                    self.triggeringElement.focus();
                                }
                            },
                            500);
                    }
                };

                self.show = function(isTriggeredByQueryString) {
                    if (!self.isOpen()) {
                        self.isOpen(true);
                        $("body").addClass("customer-success-no-scroll");
                        window.setTimeout(function() {
                                self.paneIsOpen(true);
                                window.setTimeout(function() {
                                        self.pinWrapperBelowStickyNav();
                                        if (isTriggeredByQueryString) {
                                            new filterPaneEvent("button_click", true, true, null).trigger();
                                        }

                                        $(".customer-success-filter-pane .ps-close").focus();
                                        document.addEventListener("keydown", self.changeFocus, true);
                                    },
                                    200);
                            },
                            200);
                    }
                };

                //Update the facet collections in relation to the toggled market
                self.updateFacetsFromMarket = function (toggledMarket) {
                    //Gather the market's data
                    var thisMarketData = toggledMarket.getFacetData();

                    //Get the data from all of the markets that are selected (which may or may not include toggledMarket)
                    var selectedMarketData = [];
                    var selectedMarkets = _.filter(self.markets,
                        function (selfMarket) {
                            if (selfMarket.selected()) {
                                selectedMarketData.push(selfMarket.data);
                                return true;
                            } else {
                                return false;
                            }
                        });
                    selectedMarketData = _.flatten(selectedMarketData, true);

                    var industryColl = _.findWhere(self.facetCollections(), { type: facetTypes.industry });
                    var featureColl = _.findWhere(self.facetCollections(), { type: facetTypes.features });
                    var productColl = _.findWhere(self.facetCollections(), { type: facetTypes.products });

                    if (toggledMarket.selected()) {
                        //Add the market's data to the facet collections
                        industryColl.addFacets(thisMarketData.industries);
                        featureColl.addFacets(thisMarketData.features);
                        productColl.addFacets(thisMarketData.products);
                    } else {
                        //Subtract the market's data from the facet collections
                        industryColl.subtractFacets(thisMarketData.industries, selectedMarketData);
                        featureColl.subtractFacets(thisMarketData.features, selectedMarketData);
                        productColl.subtractFacets(thisMarketData.products, selectedMarketData);
                    }

                    //Deal with whether or not the market should be disabled
                    if (selectedMarkets.length > 1) {
                        //Multiple markets are selected, so all can be picked
                        _.map(self.markets,
                            function (selfMarket) {
                                selfMarket.isDisabled(false);
                            });
                    } else {
                        //Only one selected, so disable it
                        _.map(selectedMarkets,
                            function (selfMarket) {
                                selfMarket.isDisabled(true);
                            });
                    }

                    //If the filter isn't in the midst of being reset, update the filter
                    if (!self.isResetting) {
                        self.updatefilter();
                    }
                }

                //The text for displaying the count (e.g. X of Y stories)
                self.countText = ko.computed(function () {
                    if (self.filteredDataCount() == 1) {
                        return countText.replace("##", self.totalCount()).replace("#", self.filteredDataCount());
                    }
                    return countTextPlural.replace("##", self.totalCount()).replace("#", self.filteredDataCount());
                });

                self.keyDownReset = function (vm, e) {
                    if (keyDownCheck(e.keyCode)) {
                        self.resetClick();
                    }
                }
                
                self.resetClick = function () {
                    self.reset();
                    new filterEvent(true, false).trigger();
                }

                //Reset the filter
                self.reset = function () {
                    self.isResetting = true;

                    //Select the default market, and update the filter appropriately
                    _.map(self.markets,
                        function (market) {
                            market.selected(market.isocode == currentMarket);
                            self.updateFacetsFromMarket(market);
                        });

                    //Reset the collections
                    _.map(self.facetCollections(),
                        function (facetCollection) {
                            facetCollection.reset();
                        });

                    self.isResetting = false;
                    self.updatefilter();
                }

                eventManager.subscribe("spotlight-filter-reset", function () {
                    self.reset();
                });

                eventManager.subscribe("spotlight-filter-result-page-change", function (filterDict) {
                    self.isResetting = true;

                    _.map(self.markets,
                        function (marketObj) {
                            //if the market exists in the filter, it is selected, otherwise it is deselected
                            var existing = _.findWhere(filterDict[facetTypes.markets], { id: marketObj.id });
                            if (existing) {
                                marketObj.selected(true);
                            } else {
                                marketObj.selected(false);
                            }
                        });

                    _.map(self.facetCollections(),
                        function (facetCollection) {
                            var selectedFacetIds = _.pluck(filterDict[facetCollection.type], "id");
                            facetCollection.selectFacets(selectedFacetIds, true);
                        });

                    self.isResetting = false;
                    self.updatefilter();
                });

                //Should the show more/show less element be shown?
                self.showMarketExpando = ko.computed(function () {
                    return self.markets.length > self.facetLimit;
                });

                //Toggle whether or not more than 8 (facetLimit) markets should be shown
                self.keyDownMarketToggle = function (vm, e) {
                    if (keyDownCheck(e.keyCode)) {
                        self.marketExpandoToggle(vm, e);
                    }
                }


                self.marketExpandoToggle = function (vm, e) {
                    var listIsOpen = !self.marketListOpen();
                    self.marketListOpen(listIsOpen);

                    for (var i = 0; i < self.markets.length; i++) {
                        var market = self.markets[i];
                        market.isVisible(i < self.facetLimit || listIsOpen);
                    }

                    $(e.target).siblings("[tabindex]:visible").focus();
                }

                //When filter is applied
                //Determine the count for each facet - filter the data by ones that the filter applies to, and the facet in question
                self.updatefilter = function () {
                    if (!self.isResetting) {
                        var isBeingFiltered = false;

                        var selectedDict = {};
                        var queryString = window.location.search.split("&");
                        var queryStringDict = {};
                        _.map(queryString,
                            function (entry) {
                                var splitQuery = entry.split("=");
                                var queryValue = splitQuery[1] || "";
                                var keyName = splitQuery[0];
                                if (keyName.charAt(0) === "?") {
                                    keyName = keyName.slice(1);
                                }
                                queryStringDict[keyName] = queryValue.split(",");
                            });

                        //For each facet collection
                        _.map(self.facetCollections(),
                            function (facetCollection) {
                                selectedDict[facetCollection.type] = facetCollection.getSelectedFacets();

                                //If any facets are selected, add the category to the querystring
                                if (selectedDict[facetCollection.type].length > 0) {
                                    //Add the selected facets to the querystring
                                    var ids = _.pluck(selectedDict[facetCollection.type], "id");
                                    queryStringDict[facetCollection.type] = ids;
                                } else {
                                    queryStringDict[facetCollection.type] = "";
                                }
                            });

                        //Add the selected markets to the querystring
                        var selectedMarkets = [];
                        _.map(self.markets,
                            function (market) {
                                if (market.selected()) {
                                    selectedMarkets.push(market.id);
                                    if (market.isocode != currentMarket) {
                                        isBeingFiltered = true;
                                    }
                                }
                            });

                        queryStringDict[facetTypes.markets] = selectedMarkets;

                        //Adding marketNames after query string created for filtered results page
                        var selectedMarketObjects = [];
                        _.map(self.markets,
                            function (market) {
                                if (market.selected()) {
                                    selectedMarketObjects.push({
                                        id: market.id,
                                        name: market.name
                                    });
                                }
                            });

                        selectedDict[facetTypes.markets] = selectedMarketObjects;

                        //Get all of the data from all selected markets
                        var selectedMarketData = [];
                        _.map(self.markets,
                            function (market) {
                                if (market.selected()) {
                                    selectedMarketData.push(market.data);
                                }
                            });

                        selectedMarketData = _.flatten(selectedMarketData, true);

                        //Update the counts for every facet in every collection
                        _.map(self.facetCollections(),
                            function (facetCollection) {
                                facetCollection.recalculateCounts(selectedMarketData,
                                    selectedDict[facetTypes.industry],
                                    selectedDict[facetTypes.features],
                                    selectedDict[facetTypes.products]);
                            });

                        //Next, filter the data to know how many are selected - this must be done second
                        var filteredData = selectedMarketData;
                        _.map(self.facetCollections(),
                            function (facetCollection) {
                                filteredData = facetCollection.filterDataUsingSelectedFacets(filteredData);
                            });

                        if (selectedDict[facetTypes.industry].length > 0 ||
                            selectedDict[facetTypes.features].length > 0 ||
                            selectedDict[facetTypes.products].length > 0) {
                            isBeingFiltered = true;
                        }

                        self.isFiltered(isBeingFiltered);
                        self.filteredDataCount(filteredData.length);

                        selectedDict["customerSuccessData"] = filteredData;
                        eventManager.trigger("spotlight-filter-changed", selectedDict);

                        $(self.countTextSelector).each(function (index, el) {
                            var text = $(el).data("customer-success-text-format");
                            text = text.replace("{XX}", self.filteredDataCount()).replace("{YY}", self.totalCount());
                            el.innerText = text;
                        });

                        if (!self.isInitialising) {
                            self.debounceQuerystringUpdate(queryStringDict);
                        }
                    }
                };

                initViewModel();
            };

            init();
        };

        return function initSpotlightFilter(args) {
            return args.IsExperienceEditorEditing === false ?
                new SpotlightFilters(args.scope,
                    args.countText,
                    args.countTextPlural,
                    args.industryText,
                    args.featureText,
                    args.productText,
                    args.currentMarket,
                    args.marketData,
                    args.marketsLabel) : null;
        };
    });
